<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>

        <b-row>
          <b-col md="5">
            <md-button class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousJobView"> Back</md-button>
          </b-col>

          <b-col md="4">
            <h2> <b>{{editVar.FormVal}} Job Order</b></h2>
          </b-col>
        </b-row>

        <hr class="hr-s" />

        <b-row>
          <b-col md="3">
            <label>Service Estimation No.</label>
            <b-form-input :formatter="capitalizeAll" id="serviceEstSeries" name="serviceEstSeries"
              v-model="jobOrderTpt.serviceEstSeries" :disabled="true"></b-form-input>
            <h5 class="showMoreData success mt-2" @click="showMore">Click here {{showMoreNew==true?" To Hide":" For Show"}} PO Details</h5>
          </b-col>

          <b-col md="2">
            <label>Service Estimation Date</label>
            <date-picker :format="selectDateFormat" lang="en" v-model="jobOrderTpt.serviceEstimationDate"
              :disabled="true" id="Date"></date-picker>
          </b-col>
        </b-row>

        <b-row v-if="showMoreNew==true">
          <b-col md="2">
            <label for="jobOrderTpt">Mainteinance Type</label>
            <model-list-select :list="MaintainList" isDisabled v-model="jobOrderTpt.maintenanceType" option-value="MVal"
              option-text="MText" placeholder="Select  Type"></model-list-select>
          </b-col>

          <b-col md="3">
            <label>Supervisor Name</label>
            <b-form-input :formatter="capitalizeAll" id="requestedBy" name="requestedBy"
              v-model="jobOrderTpt.requestedBy" :disabled="true"></b-form-input>
          </b-col>

          <b-col md="3">
            <label>Approved By</label>
            <b-form-input :formatter="capitalizeAll" id="approvedBy" name="approvedBy" v-model="jobOrderTpt.approvedBy"
              :disabled="true"></b-form-input>
          </b-col>
        </b-row>

        <b-row v-if="jobOrderTpt.maintenanceType != 'Office' && showMoreNew==true">
          <b-col md="2">
            <label>Vehicle No.</label>
            <b-form-input :formatter="capitalizeAll" v-if="jobOrderTpt.maintenanceType=='Vehicle'" id="jobOrderTpt"
              name="jobOrderTpt" v-model="jobOrderTpt.vehicleNo" disabled></b-form-input>

            <b-form-input :formatter="capitalizeAll" v-if="jobOrderTpt.maintenanceType=='Yard'" id="vehicleNo"
              name="vehicleNo" v-model="jobOrderTpt.vehicleYard" disabled></b-form-input>
          </b-col>

          <b-col md="2">
            <label>Engine No.</label>
            <b-form-input :formatter="capitalizeAll" id="engineNo" name="engineNo" v-model="jobOrderTpt.engineNo"
              :disabled="true"></b-form-input>
          </b-col>

          <b-col md="3">
            <label>Chassis No.</label>
            <b-form-input :formatter="capitalizeAll" id="chassisNo" name="chassisNo" v-model="jobOrderTpt.chassisNo"
              :disabled="true"></b-form-input>
          </b-col>

          <b-col md="2">
            <label>Purchase Year</label>
            <b-form-input :formatter="capitalizeAll" id="yearOfPurchase" name="yearOfPurchase"
              v-model="jobOrderTpt.yearOfPurchase" :disabled="true"></b-form-input>
          </b-col>
        </b-row>

        <b-row v-if="jobOrderTpt.maintenanceType != 'Office' && showMoreNew==true">
          <b-col md="3">
            <label>Driver Name</label>
            <b-form-input :formatter="capitalizeAll" id="driverName" name="driverName" v-model="jobOrderTpt.driverName"
              :disabled="true"></b-form-input>
          </b-col>

          <b-col md="2">
            <label>Job Order Date</label>
            <date-picker :format="selectDateFormat" lang="en" v-model="jobOrderTpt.jobOrderDate" :disabled="checkStatus"
              id="Date"></date-picker>
          </b-col>

          <b-col md="2">
            <label>Mechanic Name</label>
            <b-form-input :formatter="capitalizeAll" id="mechanicName" name="mechanicName"
              v-model="jobOrderTpt.mechanicName" :disabled="checkStatus"></b-form-input>
          </b-col>

          <b-col md="2">
            <label>Mechanic Contact</label>
            <b-form-input :formatter="capitalizeAll" id="mechanicContact" name="mechanicContact"
              v-model="jobOrderTpt.mechanicContact" :disabled="checkStatus"></b-form-input>
          </b-col>

          <b-col md="2">
            <label for="jobTypeTptStatus">Job Order Status</label>
            <model-list-select :list="statusList" v-model="jobOrderTpt.jobTypeTptStatus" option-value="SVal"
              option-text="Stxt" placeholder="Select  Status"></model-list-select>
            <span class="error" v-if="!jobOrderTpt.jobTypeTptStatus">{{statusError}}</span>
          </b-col>
        </b-row>

        <hr class="hr-border" />

        <div class="box" v-if="itemServiceDetails.length>0">
          <div class="box-header">
            <h3 class="box-title">Requried Item Details</h3>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="stockIntable" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Item Code</th>
                  <th>Item Name</th>
                  <th>Quantity</th>
                  <!-- <th>Rate per Unit</th>
                  <th>TotalAmount</th>-->
                  <th>Status</th>
                  <th>Creation Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in itemServiceDetails" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.itemCode}}</td>
                  <td>{{item.itemName }}</td>
                  <td>{{item.itemQuantity }}</td>
                  <!-- <td>{{item.ratePerUnit }}</td>
                  <td>{{item.totalAmount }}</td>-->
                  <td v-if="item.iActiveServiceStock=='1'" style="color:#009102">
                    <b>Approved</b>
                  </td>
                  <td v-else style="color:red">Not Approved</td>
                  <td>{{item.loginTime | moment}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>

        <hr class="hr-border" />
        <md-layout md-gutter class="mrgtop-button">
          <md-layout md-flex="45"></md-layout>
          <md-button class="md-raised md-primary md-button-color heght-1px mrgtop-2per" @click="addJobOrderTpt"
            id="addButtonLoader">Update</md-button>
          <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
        </md-layout>
      </md-card-content>
    </md-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop" @close="onClose"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import CustomLoader from "../../common/customLoader.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/jobOrderSheet/jobOrderSheet");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      isLoading: "",
      statusList: [
        {
          SVal: "new",
          Stxt: "New"
        },
        {
          SVal: "inProgress",
          Stxt: "In Progress"
        },
        {
          SVal: "Completed",
          Stxt: "Completed"
        }
      ],
      MaintainList: [
        {
          MVal: "Vehicle",
          MText: "Vehicle"
        },
        {
          MVal: "Yard",
          MText: "Yard"
        },
        {
          MVal: "Office",
          MText: "Office"
        }
      ],
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,

      alert: {
        content:
          this.$sessionsStorage.get("editJobOrderId") != "" &&
          this.$sessionsStorage.get("editJobOrderId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editJobOrderId") != "" &&
          this.$sessionsStorage.get("editJobOrderId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editJobOrderId") != "" &&
          this.$sessionsStorage.get("editJobOrderId") != undefined
            ? "Update"
            : "New"
      },
      showMoreNew: false,
      jobOrderTpt: {
        jobOrderTptId: "",

        serviceEstimationId: "",
        serviceEstSeries: "",
        serviceEstNumber: "",
        serviceEstimationDate: "",
        jobOrderDate: "",
        maintenanceType: "",
        containerType: "",
        containerNo: "",

        vehicleNo: "",
        vehicleId: "",
        engineNo: "",
        driverName: "",
        engineNo: "",
        chassisNo: "",
        yearOfPurchase: "",
        approvedBy: "",
        requestedBy: "",
        mechanicName: "",

        mechanicContact: "",
        jobOrderSeries: "",
        jobTypeTptStatus: "",
        department: ""
      },
      statusError: "",
      serviceDetails: {
        serviceEstimationDate: "",
        serviceEstimationId: "",
        maintenanceType: "",
        vehicleNo: "",
        vehicleYard: "",
        vehicleId: "",
        engineNo: "",
        chassisNo: "",
        yearOfPurchase: "",
        driverName: "",
        requestedBy: "",
        containerType: "",
        containerNo: "",
        department: "",
        itemForServiceEstId: ""
      },
      serviceEstimationDateError: "",

      itemModal: {
        itemForServiceEstId: "",
        serviceEstimationId: "",
        iteminStock: "",
        stockInId: "",
        itemCode: "",
        itemName: "",
        ratePerUnit: "",
        itemQuantity: "",
        totalAmount: "",
        quantityitem: "",
        itemMasterId: "",
        itemId: ""
      },
      checkStatusApproval: "",
      validate: true,
      stockInDateError: "",
      locationError: "",
      addedByPersonError: "",
      departmentError: "",
      poDateError: "",
      vendorNamError: "",
      goodsStatusError: "",
      qualityCheckError: "",

      stockReceivedDateError: "",
      employeeMaster: [
        {
          employeeName: "ajit"
        }
      ],
      locationMaster: [
        {
          pickupLocation: "mumbai"
        }
      ],
      vendorMaster: [],
      departmentMaster: [],
      itemDetail: [{}],

      vehicleDetail: [{}],
      locationDetail: [{}],
      dapartmentDetail: [],
      vendorDetail: [],
      itemServiceDetails: []
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},
  beforeDestroy() {
    this.$sessionsStorage.set("editJobOrderId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    checkStatus() {
      return (this.checkStatusApproval = this.jobOrderTpt.jobOrderTptId != "");
    },
    itemMasterList() {
      return this.itemDetail;
    },
    vehicleMasterList() {
      return this.vehicleDetail;
    },
    locationMasterList() {
      return this.locationMaster;
    },
    employeeMasterList() {
      return this.employeeMaster;
    }
  },
  methods: {
    showMore() {
      if (this.showMoreNew == false) {
        this.showMoreNew = true;
      } else {
        this.showMoreNew = false;
      }
    },
    JqueryFun() {
      return $(function() {
        return $("#stockIntable").DataTable();
      });
    },
    requestItemCallback(item) {
      this.itemModal.itemCode = item.itemCode;
      this.itemModal.itemId = item.itemId;
    },

    requestVehicleCallback(item1) {
      this.serviceDetails.engineNo = item1.engineNo;
      this.serviceDetails.chassisNo = item1.chassisNo;
      this.serviceDetails.driverName = item1.driverName;
      this.serviceDetails.vehicleId = item1.vehicleTruckId;
    },
    validateJobOrder() {
      let validate_new = true;

      if (this.jobOrderTpt.jobTypeTptStatus == "") {
        $("#jobTypeTptStatus").focus();
        this.statusError = "Select Job Order Status";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addJobOrderTpt() {
      this.validateJobOrder();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/addJobOrder.php`,
          data: JSON.stringify(this.jobOrderTpt),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
            }
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.$refs["addPop"].open();
          })

          .catch(error => {});
      }
    },

    getData() {
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/fetchToStockIn.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.vehicleDetail.length > 0) {
              this.vehicleDetail = data.vehicleDetail;
            }
            if (data.itemDetail.length > 0) {
              this.itemDetail = data.itemDetail;
            }
            if (data.departmentMaster.length > 0) {
              this.departmentMaster = data.departmentMaster;
            }
            if (
              this.$sessionsStorage.get("editServiceId") != "" &&
              this.$sessionsStorage.get("editServiceId") != undefined
            ) {
              this.viewJobOrderForm();
            }
            if (
              this.$sessionsStorage.get("editJobOrderId") != "" &&
              this.$sessionsStorage.get("editJobOrderId") != undefined
            ) {
              this.viewEditJobOrder();
            }
            this.isLoading = false;
          }
        })
        .catch(error => {});
    },
    onClose(type) {
      this.$router.push({
        path: "/jobOrderSheet/viewJobOrder"
      });
    },

    viewEditJobOrder() {
      let edit_SE = {
        editJob: "editJob",
        jobOrderTptId: this.$sessionsStorage.get("editJobOrderId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewEditJobOrder.php`,
        data: JSON.stringify(edit_SE),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            Object.keys(data.editJob[0]).map(x => {
              this.jobOrderTpt[x] = data.editJob[0][x] || "";
            });
          }
        })
        .catch(error => {});
    },

    viewJobOrderForm() {
      let edit_SE = {
        editClient: "editClient",
        serviceEstimationId: this.$sessionsStorage.get("editServiceId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/jobOrderTptAutoFill.php`,
        data: JSON.stringify(edit_SE),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            if (data.itemData.length > 0) {
              this.itemServiceDetails = data.itemData;
            }

            Object.keys(data.editClient[0]).map(x => {
              this.jobOrderTpt[x] = data.editClient[0][x] || "";
            });
          }
        })
        .catch(error => {});
    },

    itemMasterFilter(list, query) {
      return this.itemDetail.filter(x => {
        return x.itemName.toLowerCase().includes(query.toLowerCase());
      });
    },
    finalAmount() {
      let amount =
        parseFloat(this.itemModal.ratePerUnit) *
        parseFloat(this.itemModal.itemQuantity);
      this.itemModal.totalAmount = amount;
    },

    vehicleMasterFilter(list, query) {
      return this.vehicleDetail.filter(x => {
        return x.regdNo.toLowerCase().includes(query.toLowerCase());
      });
    },

    locationMasterFilter(list, query) {
      return this.locationMaster.filter(x => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },

    employeeMasterFilter(list, query) {
      return this.employeeMaster.filter(x => {
        return x.employeeName.toLowerCase().includes(query.toLowerCase());
      });
    },

    previousJobView() {
      this.$router.push({
        path: "/jobOrderSheet/viewJobOrder"
      });
    },
    openItemDialog() {
      this.$refs["dialog"].open();
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  margin-top: 1px;
}
/* .marg-top {
  margin-top: -1%;
} */

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.success{
  color:green;
}
.error {
  color: red;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}
</style>


// WEBPACK FOOTER //
// jobOrderSheet.vue?4b503030